import React from 'react'
import I18n from 'APP/I18n'
import styled from 'styled-components/native'
import { Moment } from 'moment'
import Button from 'APP/Converse/Button'
import Typography from 'APP/Converse/Typography'
import { dayToReadableText } from '../utils/helpers'
import { DIFFERENCE } from '../constants'

const Wrapper = styled.View`
  align-items: center;
  padding-top: ${({ theme }) => theme.metrics.baseMargin}px;
`

const Container = styled.View`
  align-items: center;
  width: 100%;
  margin-right: ${({ theme }) => theme.metrics.baseMargin * 2}px;
  margin-left: ${({ theme }) => theme.metrics.baseMargin * 2}px;
`

const NoAvailabilityTitle = styled(Typography)`
  margin-bottom: ${({ theme }) => theme.metrics.baseMargin * 1.5}px;
`

const StyledButton = styled(Button)`
  margin-top: ${({ theme }) => theme.metrics.baseMargin * 1.25}px;
  margin-bottom: ${({ theme }) => theme.metrics.baseMargin}px;
`

interface Props {
  onQuit: () => void
  dayDisplayedFor: Moment
  dateRange: DIFFERENCE
  difference?: number
  hasNextAvailability?: boolean
  nextAvailability?: Moment
  onNavigateToFirstAvailable: () => void
}

export const NoAvailableSlots: React.FC<Props> = ({
  hasNextAvailability = false,
  dayDisplayedFor,
  dateRange,
  difference,
  nextAvailability,
  onNavigateToFirstAvailable,
  onQuit,
}) => {
  return (
    <Wrapper>
      {hasNextAvailability && !!nextAvailability ? (
        <Container testID="CONTAINER">
          <NoAvailabilityTitle variant="bodyLargeBold">
            {I18n.t('AppointmentBooking.noAvailabilityToday')}
          </NoAvailabilityTitle>
          <Typography variant="bodyNormal">
            {I18n.t('AppointmentBooking.theEarliestAvailableIs', {
              date: dayToReadableText(nextAvailability, dayDisplayedFor),
            })}
          </Typography>
          <StyledButton
            testID="SEE_AVAILABILITY_BUTTON"
            title={I18n.t('AppointmentBooking.seeAvailability').toUpperCase()}
            variant="secondary"
            widthVariant="full"
            onPress={onNavigateToFirstAvailable}
          />
        </Container>
      ) : (
        <>
          <NoAvailabilityTitle variant="bodyLargeBold">
            {I18n.t('AppointmentBooking.noAvailability')}
          </NoAvailabilityTitle>
          <Typography variant="bodyNormal" align="center">
            {I18n.t('AppointmentBooking.noOpeningsIn', {
              difference: difference,
              timeframe: I18n.t(`AppointmentBooking.timeframe_${dateRange}`),
            })}
          </Typography>
          <StyledButton
            title={I18n.t('AppointmentBooking.findLater').toUpperCase()}
            variant="secondary"
            widthVariant="full"
            onPress={onQuit}
          />
        </>
      )}
    </Wrapper>
  )
}
